import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';

import { IbabelfishModel } from '../../interfaces/IbabelfishModel';
import { EndpointService } from '../endpoint/endpoint.service';

export interface PickupOfflineResponse {
  state: string;
  positions: string[];
  scheduleId: string;
  spaces: string[];
}

@Injectable({
  providedIn: 'root',
})
export class BabelfishService {
  private babelfishUrl: string;

  constructor(private http: HttpClient, private endpointService: EndpointService) {
    this.babelfishUrl = this.endpointService.getBabelfishUrl();
  }

  sendMessage(endUser: string, clientCode: string) {
    const body = {
      schedule: {
        endUser: endUser,
        clientCode: clientCode,
      },
    };
    const url = this.babelfishUrl + '/sendMessage';

    return this.http.post(url, body).pipe(
      tap((response) => console.log('sendMessage', response)),
      catchError(this.handleError)
    );
  }

  reclaimLights(
    scheduleId: string,
    side: string,
    processes: Record<string, string>,
    deviceSn: string,
    removeLightsTimeout?: number
  ): void {
    const ligthsData: IbabelfishModel = {
      url: '/reclaimLights',
      handlerId: 'test',
      reqId: '1234',
      res: scheduleId,
      body: JSON.stringify({
        deviceSn,
        side,
        processes,
      }),
    };
    if (removeLightsTimeout) {
      setTimeout(() => {
        console.log('execute reclaimLights');
        this.babelfish(ligthsData).subscribe();
      }, removeLightsTimeout);
    } else {
      console.log('execute reclaimLights');
      this.babelfish(ligthsData).subscribe();
    }
  }

  babelfish(
    body: IbabelfishModel | Partial<IbabelfishModel>,
    headers?: HttpHeaders | any
  ): Observable<any> {
    console.log(`${this.babelfishUrl}${body.url}`);
    return this.http.post(`${this.babelfishUrl}${body.url}`, body, {
      headers,
    });
  }

  // TODO: Improve how the errors are handled. Why return a type never?
  private handleError(err: any): Observable<never> {
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Backend returned code ${err.status}: ${err.statusText}`;
    }
    console.error('err: ', err);
    return throwError(() => errorMessage);
  }

  getToken() {
    try {
      const tokenData: Partial<IbabelfishModel> | any = {
        url: '/auth/realms/apex/protocol/openid-connect/token',
      };
      return this.babelfish(tokenData, {
        'content-type': 'x-www-form-urlencoded',
      });
    } catch (error) {
      console.error('err: ', error);
    }
  }

  startOfflineDispense(code: string): Observable<PickupOfflineResponse> {
    const endpoint = `${this.babelfishUrl}/startOfflineDispense`;
    return this.http
      .post<PickupOfflineResponse>(endpoint, { code })
      .pipe(tap((response) => console.log(`${endpoint}: `, response)));
  }

  completeOfflineDispense(code: string) {
    const endpoint = `${this.babelfishUrl}/completeOfflineDispense`;
    return this.http
      .post(endpoint, { code })
      .pipe(tap((response) => console.log(`${endpoint}: `, response)));
  }
}
